import { ITeam } from './types';

const Team: ITeam = {
  photoSrc: {
    desktop: '/assets/images/team/common.png',
    mobile: '/assets/images/team/common-mobile.png',
  },
  members: [ {
    photoSrc: '/assets/images/team/1.png',
    name: 'コズロブ ふくみ',
    position: 'CEO',
    instagramSrc: 'https://www.instagram.com/fukumikozlov/',
    specs: [
      ['BÜKIでの仕事', '「あれやりたい！」と突拍子もないアイデアを出すも残念ながら却下されがち'],
      ['今の叶えたい夢', '想像したことがどんどん叶ってしまう不思議な工場をつくること'],
      ['好きな絵本やキャラクター', 'カラスのパン屋さん、おふろだいすき、エルマー、かいじゅうたちのいるところ'],
    ],
  }, {
    photoSrc: '/assets/images/team/2.png',
    name: 'コズロブ イゴール',
    position: 'CSO',
    instagramSrc: undefined,
    specs: [
      ['BÜKIでの仕事', '計画を作り、他メンバーが計画通り動いてもらうよう日々説得することに奮闘'],
      ['今の叶えたい夢', '歴史に残るような作品をつくること　'],
      ['好きな絵本やキャラクター', 'オオカミ （ヌー、パガジー！）'],
    ],
  }, {
    photoSrc: '/assets/images/team/3.png',
    name: 'チェルビャク ピート',
    position: 'CDO',
    instagramSrc: undefined,
    specs: [
      ['BÜKIでの仕事', '「あれやりたい！」となったことをどうテクノロジーで実現できるか考えている'],
      ['今の叶えたい夢', '世界規模の子供向けチャリティープログラムをつくること'],
      ['好きな絵本やキャラクター', 'ライトニング・マックィーン'],
    ],
  }, {
    photoSrc: '/assets/images/team/4.png',
    name: 'チーフ タチアナ',
    position: 'イラストレーター',
    instagramSrc: 'https://www.instagram.com/tiuh_t/',
    specs: [
      ['BÜKIでの仕事', '子供が主人公になる絵本のイラストを描くこと'],
      ['今の叶えたい夢', '大人になった時に、子供の頃の笑顔や日常を思い出せるような絵本を残すこと'],
      ['好きな絵本やキャラクター', 'ムーミン、メリーポピンズ、ハックルベリーフィンの冒険、やねの上のカールソン'],
    ],
  }, {
    photoSrc: '/assets/images/team/5.png',
    name: 'シライ ウラディミール',
    position: 'シニア・アーキテクト',
    instagramSrc: undefined,
    specs: [
      ['BÜKIでの仕事', '夜行性。誰も作ったことがない新しいソリューションをつくること'],
      ['今の叶えたい夢', '世界中の子供が熱狂するAR/VRゲームをつくること'],
      ['好きな絵本やキャラクター', 'わんぱくダック夢冒険 （マクダック家）'],
    ],
  }, {
    photoSrc: '/assets/images/team/6.png',
    name: 'ソコロブ エフヘン',
    position: 'シニア・デベロッパー',
    instagramSrc: undefined,
    specs: [
      ['BÜKIでの仕事', '僕はコーヒーをコードに変えるマシーンさ'],
      ['今の叶えたい夢', '後世まで残る子供向けクエストゲームをつくること'],
      ['好きな絵本やキャラクター', 'チェブラーシカ'],
    ],
  }, {
    photoSrc: '/assets/images/team/7.png',
    name: 'ノビコバ スベトラーナ',
    position: 'イラストレーター',
    instagramSrc: 'https://www.instagram.com/karton.std/',
    specs: [
      ['BÜKIでの仕事', '大人が”子供っていいな”と思う絵本をつくること'],
      ['今の叶えたい夢', '作った絵本のキャラクターを3Dやリアルサイズで展示すること'],
      ['好きな絵本やキャラクター', 'The Truth About Old People、The Heart and the Bottle'],
    ],
  }, {
    photoSrc: '/assets/images/team/8.png',
    name: 'アガピトバ ナタリア',
    position: 'イラストレーター',
    instagramSrc: 'https://www.instagram.com/nataly_agapitova/',
    specs: [
      ['BÜKIでの仕事', 'ひたすら絵を描くこと。時々、子供と猫と遊び（邪魔され）ながら'],
      ['今の叶えたい夢', '世界中の子供たちに愛される絵本を最初から最後まで自分でつくってみること'],
      ['好きな絵本やキャラクター', '5ひきのすてきなねずみ、小さい魔女、Ghoulia、Tilda'],
    ],
  },  {
    photoSrc: '/assets/images/team/9.png',
    name: '森野 狐',
    position: 'アシスタントマネジャー',
    instagramSrc: 'https://www.instagram.com/foxkonkonkitune/',
    specs: [
      ['BÜKIでの仕事', '必要なことを覚えて、同じ鮮やかな夢を見ること'],
      ['今の叶えたい夢', '聡明な森の魔女になること'],
      ['好きな絵本やキャラクター', '幸福な質問（おーなり由子）、星につたえて（安東みきえ）'],
    ],
  } ],
}

export default Team;
